import React from 'react';
import { observer } from "mobx-react-lite";
import { useTranslation } from 'react-i18next';
import { ActionScope } from '../../../../../shared/action/ActionModel';
import { ElementGroup, ElementLabel } from './BaseElements';
export const ScopeSelectionActionDetail = observer(({
  scope,
  scopeSetter
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(ElementGroup, null, /*#__PURE__*/React.createElement(ElementLabel, null, t("action_editor.property_scope")), /*#__PURE__*/React.createElement("select", {
    value: scope,
    onChange: ({
      target
    }) => scopeSetter(parseInt(target.value))
  }, /*#__PURE__*/React.createElement("option", {
    value: ActionScope.Tree
  }, t("action_editor.property_scope_tree")), ")", /*#__PURE__*/React.createElement("option", {
    value: ActionScope.Global
  }, t("action_editor.property_scope_global")), ")"));
});